import React from "react";
import { Award, MessageSquare, Heart, Calendar, Users } from "lucide-react";

const DIMENSIONS = [
  {
    icon: Award,
    title: "Student Recognition",
    body:
      "How effectively student accomplishments are celebrated and displayed throughout the school.",
  },
  {
    icon: MessageSquare,
    title: "School Communication",
    body:
      "How effectively important information is communicated to students, staff, and families.",
  },
  {
    icon: Heart,
    title: "School Culture",
    body:
      "How visible school pride, student work, achievements, and community engagement are throughout the building.",
  },
  {
    icon: Calendar,
    title: "Event & Program Promotion",
    body:
      "How effectively events, activities, athletics, arts programs, and initiatives are promoted.",
  },
  {
    icon: Users,
    title: "Staff Empowerment",
    body:
      "How easily teachers and staff can create and display visual communication materials when needed.",
  },
];

export default function VCMeasures() {
  return (
    <section
      data-testid="vc-measures-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What it measures
          </div>
          <h2
            data-testid="vc-measures-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Five Dimensions of{" "}
            <span className="text-teal">School Visibility.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {DIMENSIONS.map((d, i) => {
            const Icon = d.icon;
            return (
              <div
                key={d.title}
                data-testid={`vc-measure-${i}`}
                className="group bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-7 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5"
              >
                <span className="inline-flex w-12 h-12 rounded-xl bg-navy text-white items-center justify-center mb-5 group-hover:bg-teal transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <h3 className="font-serif text-xl font-bold text-navy mb-3 leading-tight">
                  {d.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {d.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
